const jobs = {
  permissionSource: 'api::meeting.meeting',
  creationTitle: 'Create Meeting',
  creationEndPoint: '/meetings',
  detailTitle: 'Meeting: :title',
  detailEndPoint: '/meetings/:id?populate[0]=staff&populate[1]=meeting_minute',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Code',
          value: 'code',
          tag: 'input',
          type: 'text',
          placeholder: 'Code',
          required: true,
        },
        {
          label: 'Title',
          value: 'title',
          tag: 'input',
          type: 'text',
          placeholder: 'Meeting Title',
          required: true,
        },
      ],
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Date',
          value: 'date',
          tag: 'datetime-picker',
          type: 'text',
        },
        {
          label: 'Location',
          value: 'location',
          tag: 'input',
          type: 'text',
          placeholder: 'Location',
          required: true,
        },
      ],
    },
    {
      label: 'Staff',
      value: 'staff',
      tag: 'multi-select',
      dataSourceUrl: '/staffs',
      dataLabel: 'name',
    },
    {
      label: 'Agenda',
      value: 'agenda',
      tag: 'richTextarea',
    },
    {
      label: 'Meeting minute',
      value: 'meeting_minute',
      tag: 'single-select',
      dataSourceUrl: '/meeting-minutes',
      dataLabel: 'date',
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
  },
}
export default jobs
